import { Injectable } from '@odinjs/odin';
import { SuggestionItems } from 'src/interfaces/schedules-suggestions';
import { ScheduleAvailableType } from '../pseudonym-types';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { NumberFormatUtils } from '@philips-emr/patient-components/src/util/number-format-utils';
import { LocaleTypes } from '@philips-emr/patient-components/src/constants/locale-types';
import { ParseHelperUtils } from '@philips-emr/patient-components/src/util/parse-helper-utils';

export interface Price {
  currencySymbol?: string;
  total: number;
}

@Injectable
export default class PriceService {

  private language = LanguageService.getCurrentLanguage();

  Label =  {
    COPAGO: MessageService.translate('tws.appointment-suggestion.copago'),
    SCHEDULE_TOTAL: MessageService.translate('tws.appointment-suggestion.price')
  }

  calculatePrice(suggestion: SuggestionItems[], schedulePrice: Price, copagoPrice?: Price): boolean {
    let canSelect = true;
    suggestion.forEach(suggestionItem => {
      suggestionItem.suggestionItems.forEach(item => {
        if (item.availableType === ScheduleAvailableType.READ_ONLY) {
          canSelect = false;
        }
        this.getTotalPrice(item.price, item.priceNoFormatted, schedulePrice);

        if (this.isArgentina() && copagoPrice) {
          this.getTotalPrice(item.copagoPrice, item.copagoPriceNoFormatted, copagoPrice)
        }
      });
    });
    return canSelect;
  }

  private formatTotal(price: Price): string {
    return NumberFormatUtils.formatToCurrentLanguage(price.total, price.currencySymbol) || '0';
  }

  getTotalPrice(priceFormatted: string,
    priceNoFormatted: number,
    price: Price,
    verifyReturn = false as boolean,
    ieReturn = false as boolean): void {

    if (verifyReturn && ieReturn) {
      return;
    }

    if (!priceFormatted) {
      priceFormatted = '0';
    }

    if (!priceNoFormatted) {
      priceNoFormatted = 0;
    }

    const regex = /^(\S{1,100}?)\s/
    const matched = regex.exec(priceFormatted.trim());

    if (matched != null && !price.currencySymbol) {
      price.currencySymbol = matched[0];
    }
    price.total = priceNoFormatted + price.total;
  }

  private isArgentina(): boolean {
    return this.language === LocaleTypes.ARGENTINA;
  }

  getValueToDisplay(price: Price, label: string): string {
    if (label === this.Label.COPAGO && !this.isArgentina()) {
      return '';
    }
    const totalFormatted = this.formatTotal(price);
    return `${label}: ${ParseHelperUtils.parseToTextHtml(totalFormatted)}`;
  }
}
